import React, { useState, useEffect, useRef, useCallback, } from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Box, } from '@material-ui/core';

import { SearchBar, } from 'components';
import { Results, Filter, } from './components'
import { fetchBookings, fetchParkingBookings, } from 'firebaseHelpers/bookings'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));

const BookingsList = (props) => {
  const { userInfos, parkingId, restrictedParkings, limit, } = props;
  const classes = useStyles()

  const isCancelled = useRef(false)
  const [bookings, setBookings] = useState([])
  const [filters, setFilters] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const fetchData = useCallback(async (userId) => {
    setIsLoading(true)
    const bookings = parkingId ? await fetchParkingBookings(filters, parkingId) : await fetchBookings(filters, userId, restrictedParkings, limit)
    if (!isCancelled.current) {
      setIsLoading(false)
      setBookings(bookings)
    }
  }, [ parkingId, filters, restrictedParkings ])

  useEffect(() => {
    isCancelled.current = false
    if (userInfos) {
      userInfos.id && fetchData(userInfos.id)
    } else {
      fetchData()
    }

    return () => {
      isCancelled.current = true
    }
  }, [ filters, userInfos, fetchData, ]);

  const handleFilter = (filters) => {
    setFilters(filters)
  }

  return (
    <Box>
      {typeof limit === 'undefined' && (
        <SearchBar
          showSearchInput={false}
          onFilter={handleFilter}
          filterComponent={Filter}
        />
      )}
      {bookings && (
        <Results
          className={classes.results}
          bookings={bookings}
          isLoading={isLoading}
          fetchBookings={() => { fetchData(userInfos.id) }}
          limit={limit}
        />
      )}
    </Box>
  );
};

BookingsList.propTypes = {
  userInfos: PropTypes.object,
  parkingId: PropTypes.string,
  limit: PropTypes.number,
  restrictedParkings: PropTypes.arrayOf(PropTypes.string),
};

BookingsList.defaultProps = {
};

export default BookingsList;
